import { useFavicon,useImage } from '@common-fe/common-fe';

import { useOrganizationProperties } from '@/modules/transaction/hooks';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

const useOrganizationFavicon = () => {
  const { organizationProperties } = useOrganizationProperties();

  const minimizedLogoUrl = organizationProperties?.minimizedLogoUrl;
  const faviconUrl = whiteLabelingConfig?.favicon || organizationProperties?.faviconUrl || minimizedLogoUrl;
  const { isLoading, isError } = useImage(faviconUrl);
  // if(whiteLabelingConfig.favicon) {
  //   return;
  // }
  // // eslint-disable-next-line react-hooks/rules-of-hooks
  useFavicon(faviconUrl, isLoading, isError);
};

export default useOrganizationFavicon;
